export const HomeIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  ...props
}: any) => (
  <svg width={16} height={16} fill="none" {...props}>
    <path
      stroke="var(--color-icon-bright)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M1.334 14.668h13.333"
    />
    <path
      stroke="var(--color-icon-bright)"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M1.967 14.668 2 6.648c0-.407.193-.794.513-1.047L7.18 1.968a1.34 1.34 0 0 1 1.64 0l4.667 3.626c.326.253.513.64.513 1.053v8.02"
    />
    <path
      stroke="var(--color-icon-bright)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M10.333 7.332H5.666c-.553 0-1 .447-1 1v6.333h6.667V8.332c0-.553-.447-1-1-1ZM6.666 10.832v1M7 5h2"
    />
  </svg>
);
